import { Plugin } from "vue";

export default {
  install(app) {
    app.config.globalProperties.$env = (token: string) => process["env"][token];
  },
} as Plugin;
